import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "WindowOverlay"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.25 4.5H12.75V6.75H11.25V4.5ZM18.75 12.75H21V14.25H18.75V12.75ZM11.25 20.25H12.75V22.5H11.25V20.25ZM3 12.75H5.25V14.25H3V12.75ZM5.0804 7.63951L6.1409 6.57901L7.7324 8.17051L6.67115 9.23101L5.0804 7.63951ZM16.2704 8.17353L17.8612 6.58203L18.9224 7.64328L17.3309 9.23403L16.2704 8.17353ZM16.2674 18.8152L17.3279 17.754L18.9186 19.3455L17.8581 20.406L16.2674 18.8152ZM5.08266 19.3575L6.67266 17.7668L7.73391 18.8273L6.14316 20.418L5.08266 19.3575ZM3 1.5H21V3H3V1.5ZM12 18C14.4853 18 16.5 15.9853 16.5 13.5C16.5 11.0147 14.4853 9 12 9C9.51472 9 7.5 11.0147 7.5 13.5C7.5 15.9853 9.51472 18 12 18ZM12 10.5V16.5C10.3431 16.5 9 15.1569 9 13.5C9 11.8431 10.3431 10.5 12 10.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/WindowOverlay.vue"]]);
